import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormComponent } from '@app/shared/abstracts/form.component';
import * as forgot from '../state';

@Component({
  selector: 'tc-forgot-form',
  templateUrl: './forgot-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotFormComponent extends FormComponent<forgot.RequestPasswordReset> {
  @Input()
  success!: boolean;

  public form = new UntypedFormGroup({
    email: new UntypedFormControl('', Validators.compose([Validators.required, Validators.email])),
  });
}
